import gql from 'graphql-tag';
export default gql`
  query getVehicleApplication {
    getVehicleApplication {
      user {
        id
        firstName
      }
      vehicleApplication {
        applicationId
        applicationStatus
        applicationType
        orgId
        orgUserId
        calculator {
          company {
            location
            entityType
            name
            status
          }
          contact {
            firstName
            lastName
            location
            phone
          }
          introducer {
            abn
            domainName
            name
            region
          }
          shortlists {
            catalogVehicleId
            catalogYear
            distance
            distanceUnit
            duration
            durationUnit
            referenceId
          }
          fleetSize
          yearsTrading
        }
        scoreboard {
          quoteApprover
          docusignStatus
          reviewAndSignContractStatus
          validMLADate
          currentUser {
            orgLogoUUID
            orgName
            region
          }
          companyDetails {
            companyName
            companyLegalName
            abn
            nzbn
          }
          status
          statusSecondary
          statusCreditCheck
          salesforce {
            account {
              accountId
            }
            contact {
              contactId
            }
            lead {
              leadId
            }
            opportunity {
              opportunityId
            }
          }
          primaryApplicant {
            userId
            firstName
            lastName
            email
            phone
            confirmed
            identityVerificationStatus
            idScanData {
              firstName
              lastName
              middleName
              dateOfBirth
              fileUrls {
                uuid
                fileName
                mimeType
              }
              addresses {
                streetNumber
                address
                address2
                suburb
                state
                postcode
              }
              addressFull
              licenseNumber
              cardNumber
              licenseIssuedState
              licenseExpiry
              passportNumber
              passportIssuedBy
              idScan {
                errorCount
                journeyId
                journeyReference
                skipped
              }
            }
            idScanResult {
              firstName
              lastName
              middleName
              dob
              currentAddress
              previousAddress
              version
              driversLicenceNumber
              driversLicenceExpiry
              driversLicenceState
              streetNo
              streetName
              suburb
              state
              postCode
              country
              countryCode
              subPremise
            }
            applicationReviewStatus
            reviewStatus
            signContractStatus
          }
          secondaryApplicant {
            userId
            firstName
            lastName
            email
            phone
            confirmed
            identityVerificationStatus
            idScanData {
              firstName
              lastName
              middleName
              dateOfBirth
              fileUrls {
                uuid
                fileName
                mimeType
              }
              addresses {
                streetNumber
                address
                address2
                suburb
                state
                postcode
              }
              addressFull
              licenseNumber
              cardNumber
              licenseIssuedState
              licenseExpiry
              passportNumber
              passportIssuedBy
              idScan {
                errorCount
                journeyId
                journeyReference
                skipped
              }
            }
            idScanResult {
              firstName
              lastName
              middleName
              dob
              currentAddress
              previousAddress
              version
              driversLicenceNumber
              driversLicenceExpiry
              driversLicenceState
              streetNo
              streetName
              suburb
              state
              postCode
              country
              countryCode
              subPremise
            }
            applicationReviewStatus
            reviewStatus
            signContractStatus
            applicantType
          }
          businessDetails {
            entityDetails {
              companyLegalName
              companyLegalAddress
              tradingAddressSame
              tradingAddress
              businessContactNumber
              businessWebsite
              yearOfBusiness
              natureOfBusiness
              streetNo
              streetName
              suburb
              state
              postCode
              country
              countryCode
              subPremise
            }
            annualRevenue
            financeDetails {
              currentFleetSize
              numberOfEmployees
              purchaseMoreVehicles
              howManyVehicles
              valueOfApplication
              maximum
              fileUrls {
                uuid
                fileName
                mimeType
              }
              personalGuarantee
              completed
            }
          }
          entityDetails {
            entityName
            abn
            entityType
            hasSecondaryApplicant
            industry
            subDivision
            subGroup
          }
          quoteDetails {
            erpQuoteRef
            milesQuoteRef
          }
          vehicleDetails {
            bodyType
            make
            model
            rrp
            variant {
              modelYear
            }
            vehicleImage
          }
          leaseDetails {
            monthlyRentalNet
            terms
            driveAwayPrice
            fiscalValue
          }
          wetSignature
        }
      }
    }
  }
`;
